import { Command } from 'ckeditor5'

export class PasteAsTextCommand extends Command {
  async execute() {
    const editor = this.editor

    try {
      if (navigator.clipboard && navigator.clipboard.readText) {
        const plainText = await navigator.clipboard.readText()

        if (plainText) {
          // Insert as plain text without any formatting
          editor.model.change((writer: any) => {
            const textNode = writer.createText(plainText)
            editor.model.insertContent(textNode)
          })
        }
      } else {
        console.warn('Clipboard API not available')
      }
    } catch (error) {
      console.warn('Clipboard API not available for text reading')
    }
  }

  refresh() {
    this.isEnabled = true
  }
}
